$(function () {
  if($('.js-accordion-btn.is-keep-open').length) {
    $('.js-accordion-btn.is-keep-open').addClass('is-open')
    $('.js-accordion-btn.is-keep-open').next().css('display', 'block')
  }

  $('.js-accordion-btn').on('click', function () {
    $(this).next().slideToggle()
    $(this).toggleClass('is-open')
  })
})
